<ng-select (change)="onChange($event)"
           [(ngModel)]="schoolprogramcategoryValue"
           [disabled]="isDisabled"
           [items]="schoolProgramCategoryData"
           [loading]="loading"
           bindLabel="category_name"
           [placeholder]= "schoolprogramcategoryValue ? '' : ((all ? 'ALL' : 'SELECT') | translate) + ' ' + ('SCHOOL_PROGRAM_CATEGORY' | translate)"
           class="selector-style">
  <ng-template ng-option-tmp let-item="item">
    <div class="custom-option-style"  title="{{item.category_name}}">{{item.category_name}}</div>
  </ng-template>
</ng-select>
